// extracted by mini-css-extract-plugin
export default {"card":"a1-z","carouselContainer":"b1-z","carouselContent":"c1-z"};